export const translationKeys = {
  title: 'Postulación enviada con éxito',
  subTitle1: 'Muchas gracias por tu interés en trabajar con nosotros.',
  subTitle2:
    ' Nuestro equipo revisará tu solicitud dentro de las próximas 48hs hábiles y nos contactaremos a la brevedad.',
}
